import type { ReactNode, ComponentType, ComponentProps } from "react";
import { withDefaults } from "~/common/hoc/withDefaults";
import { Stack, type StackProps, styled, type BoxProps, Typography, type TypographyProps, Button } from "~/common/mui";
import { IMG_EMPTY_STATE } from "~/utils/url/staticResources";

export interface NoResultsSectionProps extends Omit<StackProps, "direction"> {
  children?: ReactNode;
}

const StyledStack = styled(Stack)(() => ({
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: "16px",
}));

const NoResultsSectionTitle = withDefaults(Typography as ComponentType<TypographyProps>, {
  variant: "headlineLarge",
});
const NoResultsSectionSubtitle = withDefaults(Typography as ComponentType<TypographyProps>, {
  variant: "bodyLarge",
  sx: { mt: -1 },
});

export interface NoResultsSectionImageProps extends Omit<BoxProps, "component" | "src" | "alt"> {
  src: string;
  alt?: string;
}

const StyledImage = styled("img")(() => ({
  width: "460px",
  height: "258px",
  objectFit: "contain",
  marginTop: "8px",
  marginBottom: "8px",
}));

export const NoResultsSectionImage = withDefaults(StyledImage as ComponentType<ComponentProps<typeof StyledImage>>, {
  alt: "",
  src: IMG_EMPTY_STATE,
});

export const NoResultsSection = Object.assign(StyledStack, {
  Title: NoResultsSectionTitle,
  Subtitle: NoResultsSectionSubtitle,
  Image: NoResultsSectionImage,
  Button: withDefaults(Button, { size: "large" }),
});
